import store from "../store";
import axios from 'axios'

const instance = axios.create();
export default class ApiService {

	constructor() {}

	static getMetadata(endpointUrl, storeResult) {
		return new Promise((resolve, reject) => {
			if (store.state.lookups.has(endpointUrl)) {
				resolve(store.getters.getCachedLookup(endpointUrl));
			} else {
				instance.get(endpointUrl)
					.then((response) => {
						if (storeResult) {
							store.commit({
								type: 'cacheLookup',
								endpoint: endpointUrl,
								data: response
							});
						}
						resolve(response);
					})
					.catch((error) => {
						reject(error);
					});
			}
		});

	}

	static getData(endpointUrl, params, storeResult) {
		return new Promise((resolve, reject) => {
			if (store.state.lookups.has(endpointUrl)) {
				resolve(store.getters.getCachedLookup(endpointUrl));
			} else {
				instance.post(endpointUrl, params)
					.then((response) => {
						if (storeResult) {
							store.commit({
								type: 'cacheLookup',
								endpoint: endpointUrl,
								data: response
							});
						}
						resolve(response);
					})
					.catch((error) => {
						reject(error);
					});
			}
		});

	}

}
